import { createApp } from 'vue/dist/vue.esm-bundler.js';
// require("./tailwind.css")

import { setup } from './wm-intro.ts';
import TeamBuilder from './components/builder.vue';
import Lineup from './components/lineup.vue';

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Lineup from './components/lineup.vue';

// import Alpine from 'alpinejs'
// window.Alpine = Alpine // optional
// Alpine.start()


// <script src="/swiper-bundle.min.js"></script>
// <link rel="stylesheet" href="/swiper-bundle.min.css">

declare global {
    interface Window {
        vm: any, // Vue.js instance
        observer: any
    }
}

function NewApp() {
  let app = createApp({})
    app.component('team-builder', TeamBuilder);
    app.component('team-lineup', Lineup);

  // Common
  return app;
}

let lastApp: any = null;
document.addEventListener("DOMContentLoaded", () => {
  if (window.vm) {
    lastApp?.unmount()
    lastApp = null;
  }
  let app = NewApp();
  window.vm = app.mount("[data-behavior='vue']")
  lastApp = app;

  window.setTimeout(() => {
  setup();
  },200)

  // Fancybox (showcase pictures)
  Fancybox.bind("[data-fancybox]", {
    // Your custom options
  });
});
